<template>
  <section class="text-question-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :options.sync="options"
    >
      <template v-slot:[`item.index`]="{ item }">
        {{ items.indexOf(item) + 1 }}
      </template>
      <template v-slot:[`item.answer`]="{ item }">
        <v-icon
          :color="item.answer.is_correct ? 'correct--text' : 'incorrect--text'"
          class="icon"
        >
          {{ item.answer.is_correct ? 'check' : 'close' }}
        </v-icon>
      </template>
      <!-- <template v-slot:items="props">
        <td class="text-center">{{ props.index + 1 }}</td>
        <td class="text-center">{{ props.item.question }}</td>
        <td class="text-center">
          {{ props.item.answer && props.item.answer.data }}
        </td>
        <td class="text-center">
          <template v-if="props.item.answer">
            <v-icon
              :color="
                props.item.answer && props.item.answer.is_correct
                  ? 'correct--text'
                  : 'incorrect--text'
              "
              class="icon"
            >
              {{
                props.item.answer && props.item.answer.is_correct
                  ? 'check'
                  : 'close'
              }}
            </v-icon>
          </template>
        </td>
      </template> -->
    </v-data-table>
  </section>
</template>

<script>
export default {
  name: 'SpinnerQuiz',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Question Number',
          align: 'center',
          sortable: false,
          value: 'index'
        },
        {
          text: 'Question',
          align: 'center',
          sortable: false,
          value: 'question'
        },
        {
          text: 'Answer',
          align: 'center',
          sortable: false,
          value: 'answer.data'
        },
        {
          text: 'Correct',
          align: 'center',
          sortable: false,
          value: 'answer'
        }
      ],
      pagination: {
        rowsPerPage: -1
      },
      options: {
        page: -1,
        mustSort: true
      },
      rowsPerPageItems: [10, 20, 30, -1]
    }
  },
  computed: {
    items() {
      let list = this.activity.answer.elements.filter(o => o.answer)
      return list
    }
  }
}
</script>

<style lang="scss">
.text-question-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }
}
</style>
